import { Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { QuoteResult } from './quote-result.model';

@Component({
    selector: 'quote-result',
    templateUrl: './quote-result.component.html',
    styleUrls: ['./quote-result.component.scss'],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None
})
export class QuoteResultComponent implements OnInit {
    @Input() data: QuoteResult;
    @Input() loading: boolean;
    @Input() quoteCalculated: boolean;
    @Input() formChanged: boolean;
    @Input() allowedToProceed: boolean;
    @Input() neededServiceType: boolean;

    @Output() placeAnOrder: EventEmitter<any> = new EventEmitter<any>();
    chargeableWeight: number;
    constructor() {}
    ngOnInit(): void {
    }
}
